import type { MenuVersionsItemsProps } from '@/interface/Menu';
import type { IconsNames } from '@eqi-investimentos/icons/web';
import type { FC } from 'react';
import Link from 'next/link';
import { Flex, Text } from '@eqi-investimentos/react';
import { Icon } from '@/components/atoms/Icon';
export const MenuItem: FC<MenuItemProps> = ({
  iconName,
  isActive,
  isMenuOpen,
  name,
  target = '_self',
  url,
  onClick,
  unauthorized
}) => {
  const color = isActive ? 'content.brand' : 'content.primary';
  return <Flex as={Link} href={unauthorized ? '#' : url} target={target} flexDir={isMenuOpen ? 'row' : 'column'} justifyContent={isMenuOpen ? 'flex-start' : 'center'} alignItems="center" gap="5" w="full" h="1.875rem" my="3" transition="all 1s ease" _hover={{
    p: {
      color: 'action.active.brandLight'
    },
    'svg,svg>g,svg>path': {
      color: 'action.active.brandLight !important'
    }
  }} onClick={e => {
    if (unauthorized) {
      e.stopPropagation();
    }
    onClick(url);
  }} data-sentry-element="Flex" data-sentry-component="MenuItem" data-sentry-source-file="Item.tsx">
      {iconName && <Icon iconName={iconName} w="24" h="24" color={color} strokeWidth="1.5" transition="all 300ms ease-in-out" />}
      <Text className="animate-fade" display={isMenuOpen ? 'block' : 'none'} mt="0.5" lineHeight="5" color={color} textAlign="center" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="Item.tsx">
        {name}
      </Text>
    </Flex>;
};
type MenuItemProps = Pick<MenuVersionsItemsProps, 'name'> & {
  iconName: IconsNames | null;
  isActive: boolean;
  isMenuOpen: boolean;
  target?: MenuVersionsItemsProps['target'];
  url: NonNullable<MenuVersionsItemsProps['url']>;
  onClick: (url: string) => void;
  unauthorized: boolean;
};